module.exports = __webpack_public_path__ + "66b0e2828b3db9bbeacb5165e6981b65.svg";